import AOS from "aos";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../../api/api";
import TextMarqueSection from "../../common/TextMarqueSection";

// Helper to strip HTML tags
function stripHtml(html) {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

// Helper to truncate text
function truncate(text, maxLength) {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
}

const SectionSeven = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const data = await fetchData("/blog/blogs/");

        const mapped = (data || []).map((b) => {
          const rawExcerpt = stripHtml(b.description || "");
          return {
            title: b.title || "",
            author: b.author || "",
            category: b?.category?.name || "",
            image: b.image || "",
            excerpt: truncate(rawExcerpt, 180),
            slug: b.slug || "",
          };
        });

        if (alive) setBlogs(mapped);
      } catch (e) {
        if (alive) setErr("Failed to load blogs. Please try again.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section style={{ padding: "40px 0", overflow: "hidden" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 16px" }}>
        <p
          className="our-services discover-our-cases"
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
          data-aos="fade-up"
        >
          News & Latest Updates
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "32px",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          <h2
            style={{
              fontSize: "clamp(24px, 5vw, 36px)",
              fontWeight: "bold",
              color: "white",
              textAlign: "center",
            }}
            data-aos="fade-down"
          >
            Check Inside Story
          </h2>
          <Link to="/blog">
            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 24px",
                backgroundColor: "#ff7d61",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "16px",
                transition: "background-color 0.3s",
              }}
            >
              See More News
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M6.66669 16H25.3334"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20 21.3333L25.3333 16"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M20 10.6666L25.3333 16"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </Link>
        </div>

        {loading && <p style={{ color: "white" }}>Loading blogs...</p>}
        {err && !loading && <p style={{ color: "red" }}>{err}</p>}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "24px",
          }}
        >
          {blogs.map((item, index) => (
            <div
              key={index}
              style={{
                borderRadius: "12px",
                color: "white",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                transition: "transform 0.3s",
              }}
              data-aos={index % 2 === 0 ? "fade-up" : "fade-down"}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <Link to={`/blog/${item.slug}`}>
                <img
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "12px 12px 0 0",
                    cursor: "pointer",
                  }}
                  src={item.image}
                  alt={`news-img-${index}`}
                />
              </Link>
              <div style={{ padding: "16px" }}>
                <p
                  style={{
                    fontSize: "18px",
                    color: "#6b7280",
                    marginBottom: "8px",
                  }}
                >
                  {item.category}
                </p>
                <Link to={`/blog/${item.slug}`} style={{ textDecoration: "none" }}>
                  <h2
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      color: "white",
                      marginBottom: "8px",
                      cursor: "pointer",
                    }}
                  >
                    {item.title}
                  </h2>
                </Link>
                <p style={{ color: "white", marginBottom: "12px" }}>
                  {item.excerpt}
                </p>
                <Link
                  to={`/blog/${item.slug}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "#ff7d61",
                    fontWeight: "500",
                    textDecoration: "none",
                    fontSize: "14px",
                  }}
                >
                  Read More
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path
                      d="M6.66669 16H25.3334"
                      stroke="#ff7d61"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M20 21.3333L25.3333 16"
                      stroke="#ff7d61"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M20 10.6666L25.3333 16"
                      stroke="#ff7d61"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <TextMarqueSection />
    </section>
  );
};

export default SectionSeven;
